import * as React from 'react';
import { highlightSearchTerms } from '@/config/search/search-utils';

/**
 * HighlightedText — small wrapper over `highlightSearchTerms` so cells
 * can call `<HighlightedText text={x} searchTerm={query} />` instead of
 * threading the utility's React-element output by hand. Mirrors the
 * cherie-app component of the same name; behavior is driven by the
 * shared `globalSearchConfig` (yellow-200 / yellow-800, multi-term
 * split on whitespace, case-insensitive by default).
 *
 * If `searchTerm` is empty, falsy, or there's no match, the text
 * renders as-is — no extra wrapper, no flicker.
 */

export interface HighlightedTextProps {
  text: string | null | undefined;
  searchTerm: string | null | undefined;
  className?: string;
  highlightClassName?: string;
  highlightStyle?: React.CSSProperties;
  caseSensitive?: boolean;
}

export function HighlightedText({
  text,
  searchTerm,
  className,
  highlightClassName,
  highlightStyle,
  caseSensitive,
}: HighlightedTextProps) {
  const content = highlightSearchTerms(text ?? '', searchTerm ?? '', {
    className: highlightClassName,
    style: highlightStyle,
    caseSensitive,
  });

  if (typeof content === 'string') {
    return className ? <span className={className}>{content}</span> : <>{content}</>;
  }

  return <span className={className}>{content}</span>;
}

export default HighlightedText;
